/* PDFCommunity - Fill in a PDF / add text (v147, light version).
   One PDF. (1) Its form fields (AcroForm) are shown as an HTML form, grouped
   per page, with their current values; what the visitor changes is written
   back with pdf-lib and the fields get a new look (appearance), optionally
   flattened. (2) Text boxes, a check mark or a cross can be placed on a
   preview of any page (also a scanned form without fields) and are written
   into the page content, upright as the reader sees the page.
   Existing text of the PDF can't be changed: this is not a PDF editor.
   Fonts: the standard PDF font (Helvetica) where it can write the text;
   Noto Sans, embedded whole, for other Latin, Greek and Cyrillic letters
   (subsetting with this fontkit build drops glyphs: measured, v147); anything
   else (Chinese, Japanese, Korean, Hebrew, Arabic, a mix of alphabets) is
   drawn as letter shapes with the watermark's fonts (PCTools.fonts), so a
   filled-in Chinese form doesn't grow by 6 MB. The field keeps its real value. */
(function(){
  'use strict';
  var LANG = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);
  var MSG = {
    en: {
      working: 'Saving your changes…',
      fieldsHint: 'Change what you need; fields you leave alone stay as they are.',
      fieldsSkipped: '{0} field(s) can\'t be changed here (signatures, buttons or formatted text).',
      noFields: 'This PDF has no fillable form fields. Click on the page below to add text where you need it.',
      fieldsReadFail: 'The form fields of this PDF could not be read. You can still add text on the page below.',
      pageGroup: 'Page {0}',
      otherGroup: 'Other fields',
      choose: '(none)',
      boxLabel: 'Text box: {0}. Move it with the arrow keys; Delete removes it.',
      boxEmpty: 'empty',
      checkLabel: 'Check mark. Move it with the arrow keys; Delete removes it.',
      crossLabel: 'Cross. Move it with the arrow keys; Delete removes it.',
      boxPos: 'Moved: {0} from the left, {1} from the top.',
      boxRemoved: 'Box removed.',
      nothing: 'Change a form field or add text first.',
      onlyFirst: 'Only {0} was filled in: this tool works on one PDF at a time.',
      infoDone: 'filled-in PDF ready',
      chars: 'The text in {0} contains characters that can\'t be drawn here (for example emoji or rare symbols).',
      aTextBox: 'a text box',
      fieldFail: 'The field “{0}” could not be filled in.',
      flattenFail: 'The form could not be flattened. Try again without “Flatten the form afterwards”.',
      flattenKept: "These fields could not be flattened (characters the built-in font cannot show) and stay fillable: {0}.",
      flattenFormError: "The form could not be read completely: fields without a stored look stay fillable."
    },
    nl: {
      working: 'Je wijzigingen worden opgeslagen…',
      fieldsHint: 'Wijzig wat je nodig hebt; velden die je niet aanraakt, blijven zoals ze zijn.',
      fieldsSkipped: '{0} veld(en) kun je hier niet wijzigen (handtekeningen, knoppen of opgemaakte tekst).',
      noFields: 'Deze PDF heeft geen invulbare formuliervelden. Klik hieronder op de pagina om tekst toe te voegen waar je die nodig hebt.',
      fieldsReadFail: 'De formuliervelden van deze PDF konden niet gelezen worden. Je kunt hieronder nog wel tekst op de pagina zetten.',
      pageGroup: 'Pagina {0}',
      otherGroup: 'Andere velden',
      choose: '(geen)',
      boxLabel: 'Tekstvak: {0}. Verplaats het met de pijltjestoetsen; Delete verwijdert het.',
      boxEmpty: 'leeg',
      checkLabel: 'Vinkje. Verplaats het met de pijltjestoetsen; Delete verwijdert het.',
      crossLabel: 'Kruisje. Verplaats het met de pijltjestoetsen; Delete verwijdert het.',
      boxPos: 'Verplaatst: {0} van links, {1} van boven.',
      boxRemoved: 'Vak verwijderd.',
      nothing: 'Wijzig eerst een formulierveld of voeg tekst toe.',
      onlyFirst: 'Alleen {0} is ingevuld: deze tool werkt met één PDF tegelijk.',
      infoDone: 'ingevulde PDF klaar',
      chars: 'De tekst in {0} bevat tekens die hier niet getekend kunnen worden (bv. emoji of zeldzame symbolen).',
      aTextBox: 'een tekstvak',
      fieldFail: 'Het veld “{0}” kon niet ingevuld worden.',
      flattenFail: 'Het formulier kon niet afgevlakt worden. Probeer opnieuw zonder “Formulier daarna afvlakken”.',
      flattenKept: "Deze velden konden niet afgevlakt worden (tekens die het ingebouwde lettertype niet kan tonen) en blijven invulbaar: {0}.",
      flattenFormError: "Het formulier kon niet volledig gelezen worden: velden zonder opgeslagen weergave blijven invulbaar."
    },
    fr: {
      working: 'Enregistrement de vos modifications…',
      fieldsHint: 'Modifiez ce dont vous avez besoin ; les champs auxquels vous ne touchez pas restent tels quels.',
      fieldsSkipped: '{0} champ(s) ne peuvent pas être modifiés ici (signatures, boutons ou texte mis en forme).',
      noFields: 'Ce PDF n\'a pas de champs de formulaire à remplir. Cliquez sur la page ci-dessous pour ajouter du texte là où vous en avez besoin.',
      fieldsReadFail: 'Les champs de formulaire de ce PDF n\'ont pas pu être lus. Vous pouvez quand même ajouter du texte sur la page ci-dessous.',
      pageGroup: 'Page {0}',
      otherGroup: 'Autres champs',
      choose: '(aucun)',
      boxLabel: 'Zone de texte : {0}. Déplacez-la avec les flèches ; Suppr la supprime.',
      boxEmpty: 'vide',
      checkLabel: 'Coche. Déplacez-la avec les flèches ; Suppr la supprime.',
      crossLabel: 'Croix. Déplacez-la avec les flèches ; Suppr la supprime.',
      boxPos: 'Déplacée : {0} depuis la gauche, {1} depuis le haut.',
      boxRemoved: 'Zone supprimée.',
      nothing: 'Modifiez d\'abord un champ du formulaire ou ajoutez du texte.',
      onlyFirst: 'Seul {0} a été rempli : cet outil traite un PDF à la fois.',
      infoDone: 'PDF rempli prêt',
      chars: 'Le texte de {0} contient des caractères qui ne peuvent pas être dessinés ici (par ex. des emoji ou des symboles rares).',
      aTextBox: 'une zone de texte',
      fieldFail: 'Le champ « {0} » n\'a pas pu être rempli.',
      flattenFail: 'Le formulaire n\'a pas pu être aplati. Réessayez sans « Aplatir le formulaire ensuite ».',
      flattenKept: "Ces champs n’ont pas pu être aplatis (caractères que la police intégrée ne peut pas afficher) et restent modifiables : {0}.",
      flattenFormError: "Le formulaire n’a pas pu être lu entièrement : les champs sans apparence enregistrée restent modifiables."
    },
    de: {
      working: 'Ihre Änderungen werden gespeichert…',
      fieldsHint: 'Ändern Sie, was Sie brauchen; Felder, die Sie nicht anfassen, bleiben, wie sie sind.',
      fieldsSkipped: '{0} Feld(er) können hier nicht geändert werden (Unterschriften, Schaltflächen oder formatierter Text).',
      noFields: 'Dieses PDF hat keine ausfüllbaren Formularfelder. Klicken Sie unten auf die Seite, um dort Text hinzuzufügen, wo Sie ihn brauchen.',
      fieldsReadFail: 'Die Formularfelder dieses PDFs konnten nicht gelesen werden. Sie können unten trotzdem Text auf die Seite setzen.',
      pageGroup: 'Seite {0}',
      otherGroup: 'Weitere Felder',
      choose: '(keine Auswahl)',
      boxLabel: 'Textfeld: {0}. Mit den Pfeiltasten verschieben; Entf entfernt es.',
      boxEmpty: 'leer',
      checkLabel: 'Häkchen. Mit den Pfeiltasten verschieben; Entf entfernt es.',
      crossLabel: 'Kreuz. Mit den Pfeiltasten verschieben; Entf entfernt es.',
      boxPos: 'Verschoben: {0} von links, {1} von oben.',
      boxRemoved: 'Feld entfernt.',
      nothing: 'Ändern Sie zuerst ein Formularfeld oder fügen Sie Text hinzu.',
      onlyFirst: 'Nur {0} wurde ausgefüllt: Dieses Tool bearbeitet ein PDF auf einmal.',
      infoDone: 'ausgefülltes PDF fertig',
      chars: 'Der Text in {0} enthält Zeichen, die hier nicht gezeichnet werden können (z. B. Emoji oder seltene Symbole).',
      aTextBox: 'einem Textfeld',
      fieldFail: 'Das Feld „{0}“ konnte nicht ausgefüllt werden.',
      flattenFail: 'Das Formular konnte nicht abgeflacht werden. Versuchen Sie es ohne „Formular danach abflachen“.',
      flattenKept: "Diese Felder konnten nicht abgeflacht werden (Zeichen, die die eingebaute Schrift nicht darstellen kann) und bleiben ausfüllbar: {0}.",
      flattenFormError: "Das Formular ließ sich nicht vollständig lesen: Felder ohne gespeichertes Erscheinungsbild bleiben ausfüllbar."
    },
    es: {
      working: 'Guardando tus cambios…',
      fieldsHint: 'Cambia lo que necesites; los campos que no toques se quedan como están.',
      fieldsSkipped: '{0} campo(s) no se pueden cambiar aquí (firmas, botones o texto con formato).',
      noFields: 'Este PDF no tiene campos de formulario rellenables. Haz clic en la página de abajo para añadir texto donde lo necesites.',
      fieldsReadFail: 'No se pudieron leer los campos del formulario de este PDF. Aun así puedes añadir texto en la página de abajo.',
      pageGroup: 'Página {0}',
      otherGroup: 'Otros campos',
      choose: '(ninguno)',
      boxLabel: 'Cuadro de texto: {0}. Muévelo con las flechas; Supr lo elimina.',
      boxEmpty: 'vacío',
      checkLabel: 'Marca de verificación. Muévela con las flechas; Supr la elimina.',
      crossLabel: 'Cruz. Muévela con las flechas; Supr la elimina.',
      boxPos: 'Movido: {0} desde la izquierda, {1} desde arriba.',
      boxRemoved: 'Cuadro eliminado.',
      nothing: 'Primero cambia un campo del formulario o añade texto.',
      onlyFirst: 'Solo se rellenó {0}: esta herramienta trabaja con un PDF cada vez.',
      infoDone: 'PDF rellenado listo',
      chars: 'El texto de {0} contiene caracteres que no se pueden dibujar aquí (por ejemplo, emoji o símbolos poco comunes).',
      aTextBox: 'un cuadro de texto',
      fieldFail: 'No se pudo rellenar el campo «{0}».',
      flattenFail: 'No se pudo aplanar el formulario. Inténtalo de nuevo sin «Aplanar el formulario después».',
      flattenKept: "Estos campos no se pudieron aplanar (caracteres que la fuente integrada no puede mostrar) y siguen siendo editables: {0}.",
      flattenFormError: "No se pudo leer el formulario por completo: los campos sin una apariencia guardada siguen siendo editables."
    },
    pt: {
      working: 'Salvando suas alterações…',
      fieldsHint: 'Altere o que precisar; os campos em que você não mexer continuam como estão.',
      fieldsSkipped: '{0} campo(s) não podem ser alterados aqui (assinaturas, botões ou texto formatado).',
      noFields: 'Este PDF não tem campos de formulário preenchíveis. Clique na página abaixo para adicionar texto onde precisar.',
      fieldsReadFail: 'Não foi possível ler os campos do formulário deste PDF. Você ainda pode adicionar texto na página abaixo.',
      pageGroup: 'Página {0}',
      otherGroup: 'Outros campos',
      choose: '(nenhum)',
      boxLabel: 'Caixa de texto: {0}. Mova com as setas; Delete remove.',
      boxEmpty: 'vazia',
      checkLabel: 'Marca de seleção. Mova com as setas; Delete remove.',
      crossLabel: 'Xis. Mova com as setas; Delete remove.',
      boxPos: 'Movido: {0} da esquerda, {1} do topo.',
      boxRemoved: 'Caixa removida.',
      nothing: 'Primeiro altere um campo do formulário ou adicione texto.',
      onlyFirst: 'Só {0} foi preenchido: esta ferramenta trabalha com um PDF por vez.',
      infoDone: 'PDF preenchido pronto',
      chars: 'O texto em {0} contém caracteres que não podem ser desenhados aqui (por ex. emoji ou símbolos raros).',
      aTextBox: 'uma caixa de texto',
      fieldFail: 'Não foi possível preencher o campo “{0}”.',
      flattenFail: 'Não foi possível achatar o formulário. Tente de novo sem “Achatar o formulário depois”.',
      flattenKept: "Estes campos não puderam ser achatados (caracteres que a fonte embutida não consegue mostrar) e continuam editáveis: {0}.",
      flattenFormError: "Não foi possível ler o formulário por completo: os campos sem uma aparência salva continuam editáveis."
    },
    it: {
      working: 'Salvataggio delle modifiche…',
      fieldsHint: 'Modifica ciò che ti serve; i campi che non tocchi restano come sono.',
      fieldsSkipped: '{0} campo/i non si possono modificare qui (firme, pulsanti o testo formattato).',
      noFields: 'Questo PDF non ha campi modulo compilabili. Fai clic sulla pagina qui sotto per aggiungere testo dove ti serve.',
      fieldsReadFail: 'Non è stato possibile leggere i campi modulo di questo PDF. Puoi comunque aggiungere testo sulla pagina qui sotto.',
      pageGroup: 'Pagina {0}',
      otherGroup: 'Altri campi',
      choose: '(nessuno)',
      boxLabel: 'Casella di testo: {0}. Spostala con le frecce; Canc la elimina.',
      boxEmpty: 'vuota',
      checkLabel: 'Segno di spunta. Spostalo con le frecce; Canc lo elimina.',
      crossLabel: 'Croce. Spostala con le frecce; Canc la elimina.',
      boxPos: 'Spostato: {0} da sinistra, {1} dall\'alto.',
      boxRemoved: 'Casella eliminata.',
      nothing: 'Prima modifica un campo del modulo o aggiungi del testo.',
      onlyFirst: 'È stato compilato solo {0}: questo strumento lavora su un PDF alla volta.',
      infoDone: 'PDF compilato pronto',
      chars: 'Il testo in {0} contiene caratteri che qui non si possono disegnare (per esempio emoji o simboli rari).',
      aTextBox: 'una casella di testo',
      fieldFail: 'Non è stato possibile compilare il campo «{0}».',
      flattenFail: 'Non è stato possibile appiattire il modulo. Riprova senza «Appiattisci il modulo dopo».',
      flattenKept: "Questi campi non si sono potuti appiattire (caratteri che il font integrato non può mostrare) e restano compilabili: {0}.",
      flattenFormError: "Non è stato possibile leggere del tutto il modulo: i campi senza un aspetto salvato restano compilabili."
    }, pl: {
      working: "Zapisywanie zmian…",
      fieldsHint: "Zmień to, czego potrzebujesz; pola, których nie ruszysz, zostaną bez zmian.",
      fieldsSkipped: "Pól, których nie da się tu edytować (podpisy, przyciski lub tekst sformatowany): {0}.",
      noFields: "Ten PDF nie ma pól formularza do wypełnienia. Kliknij stronę poniżej, aby dodać tekst tam, gdzie go potrzebujesz.",
      fieldsReadFail: "Nie udało się odczytać pól formularza tego PDF. Nadal możesz dodać tekst na stronie poniżej.",
      pageGroup: "Strona {0}",
      otherGroup: "Inne pola",
      choose: "(brak)",
      boxLabel: "Pole tekstowe: {0}. Przesuwaj je strzałkami; Delete je usuwa.",
      boxEmpty: "puste",
      checkLabel: "Znak zaznaczenia. Przesuwaj go strzałkami; Delete go usuwa.",
      crossLabel: "Krzyżyk. Przesuwaj go strzałkami; Delete go usuwa.",
      boxPos: "Przesunięto: {0} od lewej, {1} od góry.",
      boxRemoved: "Usunięto pole.",
      nothing: "Najpierw zmień pole formularza lub dodaj tekst.",
      onlyFirst: "Wypełniono tylko {0}: to narzędzie działa na jednym pliku PDF naraz.",
      infoDone: "Wypełniony PDF jest gotowy",
      chars: "Tekst w {0} zawiera znaki, których nie da się tu narysować (np. emoji lub rzadkie symbole).",
      aTextBox: "polu tekstowym",
      fieldFail: "Nie udało się wypełnić pola „{0}”.",
      flattenFail: "Nie udało się spłaszczyć formularza. Spróbuj ponownie bez opcji „Potem spłaszcz formularz”.",
      flattenKept: "Tych pól nie udało się spłaszczyć (znaki, których wbudowana czcionka nie potrafi wyświetlić), więc nadal można je wypełniać: {0}.",
      flattenFormError: "Nie udało się w pełni odczytać formularza: pola bez zapisanego wyglądu nadal można wypełniać."
    }
  };
  var M = MSG[LANG] || MSG.en;
  function t(key){
    var s = M[key] != null ? M[key] : MSG.en[key];
    return pcFill.apply(null, [s].concat(Array.prototype.slice.call(arguments, 1)));
  }
  function myError(text){ var e = new Error(text); e.userFacing = true; return e; }

  var FILL = {
    PREVIEW_MAX_W: 720,      // CSS px, as Sign
    PREVIEW_MAX_SCALE: 4,
    KEY_STEP: 0.01, KEY_STEP_BIG: 0.05, // share of the page per arrow key
    POS_MAX: 0.98,           // a box keeps at least this much of the page to its right and below
    LINE_EM: 1.2,            // line height of a text box, in font sizes (CSS line-height too)
    BASE_EM: 0.95,           // first baseline below the top of the box (Helvetica/Arial at line-height 1.2)
    NEW_BOX_X: 0.1, NEW_BOX_Y: 0.1, NEW_BOX_STEP: 0.04, NEW_BOX_ROWS: 15, // "Add text box" without a click
    STAMP_UNITS: 100,        // the stamp paths are drawn in a 100 x 100 box = one font size
    STAMP_LINE: 12,          // ...with lines this wide
    POS_ANNOUNCE_MS: 300,
    FIELD_PAD: 2,            // pt between a field's border and its text (letter shapes)
    FIELD_CAP: 0.7,          // cap height in font sizes, centred in a one-line field
    FIELD_AUTO_MAX: 12,      // pt: auto-sized text (DA size 0) is never larger
    PATH_UNITS: 1000         // PCTools.fonts.textPath: 1 unit = 1/1000 of the font size
  };
  var COLORS = { black: [0, 0, 0], blue: [0.102, 0.239, 0.561] }; // = #1a3d8f, Sign's blue
  var CSS_COLORS = { black: '#000000', blue: '#1a3d8f' };
  var STAMPS = { check: 'M10 55 L40 85 L90 15', cross: 'M15 15 L85 85 M85 15 L15 85' };
  var RTL_RE = /[֐-ࣿיִ-﷿ﹰ-﻿]/;

  var $ = function(id){ return document.getElementById(id); };
  function el(id){ return $('fill-' + id); }
  function clamp(v, lo, hi){ return Math.max(lo, Math.min(hi, v)); }

  var fill = { previewFor: null, pdf: null, pages: 0, page: 1, rendering: 0, vw: 595, vh: 842,
    fields: [], fieldsRead: false, boxes: [], sel: null };

  /* ---------- form fields: read ---------- */
  function decoded(o){
    if(o instanceof PDFLib.PDFString || o instanceof PDFLib.PDFHexString) return o.decodeText();
    return '';
  }
  function pageIndexer(doc){
    var pages = doc.getPages(), byRef = new Map();
    pages.forEach(function(p, i){ byRef.set(p.ref.toString(), i); });
    return function(field){
      var w = field.acroField.getWidgets()[0];
      if(!w) return -1;
      var p = w.P();
      if(p && byRef.has(p.toString())) return byRef.get(p.toString());
      var ref = doc.context.getObjectRef(w.dict), page = ref ? doc.findPageForAnnotationRef(ref) : null;
      return page ? pages.indexOf(page) : -1;
    };
  }
  function describeField(f, pageOf){
    var L = PDFLib, name = f.getName();
    var d = { name: name, label: decoded(f.acroField.dict.lookup(L.PDFName.of('TU'))).trim() || name, page: pageOf(f), readOnly: f.isReadOnly() };
    if(f instanceof L.PDFTextField) return Object.assign(d, { type: 'text', value: f.getText() || '', multiline: f.isMultiline(), maxLength: f.getMaxLength() });
    if(f instanceof L.PDFCheckBox) return Object.assign(d, { type: 'check', value: f.isChecked() });
    if(f instanceof L.PDFRadioGroup) return Object.assign(d, { type: 'radio', value: f.getSelected() || '', options: f.getOptions() });
    if(f instanceof L.PDFDropdown) return Object.assign(d, { type: 'select', value: f.getSelected()[0] || '', options: choicesOf(f) });
    if(f instanceof L.PDFOptionList) return Object.assign(d, { type: 'list', value: f.getSelected(), options: choicesOf(f), multi: f.isMultiselect() });
    return null; // push buttons and signature fields
  }
  /* (v157) A list's entries as { value: export value (what /V holds), label: what the reader sees }.
     pdf-lib's getOptions/select only know the shown text: an [export, display] pair got the display text as its value. */
  function choicesOf(f){
    return f.acroField.getOptions().map(function(o){
      var value = decoded(o.value), label = o.display ? decoded(o.display) : value;
      return { value: value, label: label || value };
    });
  }
  var RICH_TEXT_RE = /rich text/i; // pdf-lib refuses to read rich-text fields
  function readFields(doc){
    if(!(doc.catalog.lookup(PDFLib.PDFName.of('AcroForm')) instanceof PDFLib.PDFDict)) return { list: [], skipped: 0 };
    var pageOf = pageIndexer(doc), list = [], skipped = 0;
    doc.getForm().getFields().forEach(function(f){
      var d = null;
      try{ d = describeField(f, pageOf); }
      catch(e){ if(!RICH_TEXT_RE.test(e && e.message)) throw e; } // counted below as "can't be changed here"
      if(d) list.push(d); else skipped++;
    });
    return { list: list, skipped: skipped };
  }

  /* ---------- form fields: the HTML form ---------- */
  function fieldControl(d, i){
    var id = 'fill-f-' + i, row = document.createElement('div');
    row.className = 'fill-row';
    if(d.type === 'check'){
      var lab = document.createElement('label'), cb = document.createElement('input');
      lab.className = 'sign-check';
      cb.type = 'checkbox'; cb.id = id; cb.checked = d.value; cb.disabled = d.readOnly;
      lab.append(cb, ' ' + d.label);
      row.appendChild(lab);
      d.read = function(){ return cb.checked; };
      return row;
    }
    if(d.type === 'radio') return radioControl(d, i, row);
    var label = document.createElement('label');
    label.className = 'text-field'; label.htmlFor = id; label.textContent = d.label;
    var input = d.type === 'text' ? textInput(d) : selectInput(d);
    input.id = id; input.disabled = d.readOnly;
    row.append(label, input);
    return row;
  }
  function textInput(d){
    var input = document.createElement(d.multiline ? 'textarea' : 'input');
    if(!d.multiline) input.type = 'text';
    input.className = 'text-input'; input.autocomplete = 'off'; input.value = d.value;
    if(d.maxLength) input.maxLength = d.maxLength;
    d.read = function(){ return input.value; };
    return input;
  }
  function selectInput(d){
    var sel = document.createElement('select'), multi = d.type === 'list' && d.multi;
    sel.className = 'sign-select'; sel.multiple = multi;
    var opts = d.options.slice(), now = d.type === 'list' ? d.value : [d.value];
    var known = function(v){ return opts.some(function(o){ return o.value === v; }); };
    now.forEach(function(v){ if(v && !known(v)) opts.push({ value: v, label: v }); }); // an edited combo box value
    if(!multi) sel.add(new Option(t('choose'), ''));
    opts.forEach(function(o){ sel.add(new Option(o.label, o.value, false, now.indexOf(o.value) >= 0)); });
    if(!multi && !d.value) sel.value = '';
    d.read = function(){
      var picked = Array.prototype.filter.call(sel.options, function(o){ return o.selected && o.value; }).map(function(o){ return o.value; });
      return d.type === 'list' ? picked : (picked[0] || '');
    };
    return sel;
  }
  function radioControl(d, i, row){
    var set = document.createElement('fieldset'), legend = document.createElement('legend');
    set.className = 'fill-radios'; legend.className = 'text-field'; legend.textContent = d.label;
    set.appendChild(legend);
    var inputs = d.options.map(function(v, k){
      var lab = document.createElement('label'), r = document.createElement('input');
      lab.className = 'sign-check';
      r.type = 'radio'; r.name = 'fill-r-' + i; r.id = 'fill-f-' + i + '-' + k; r.value = v; r.checked = v === d.value; r.disabled = d.readOnly;
      lab.append(r, ' ' + v);
      set.appendChild(lab);
      return r;
    });
    d.read = function(){ var on = inputs.filter(function(r){ return r.checked; })[0]; return on ? on.value : ''; };
    row.appendChild(set);
    return row;
  }
  function groupFields(list){
    var groups = new Map();
    list.forEach(function(d, i){
      if(!groups.has(d.page)) groups.set(d.page, []);
      groups.get(d.page).push(fieldControl(d, i));
    });
    return Array.from(groups.keys()).sort(function(a, b){ return (a < 0 ? Infinity : a) - (b < 0 ? Infinity : b); }).map(function(p){
      var set = document.createElement('fieldset'), legend = document.createElement('legend');
      set.className = 'fill-group';
      legend.textContent = p < 0 ? t('otherGroup') : t('pageGroup', p + 1);
      set.appendChild(legend);
      groups.get(p).forEach(function(row){ set.appendChild(row); });
      return set;
    });
  }
  function showFields(read, failed){
    var box = el('fields'), note = el('forms-note');
    fill.fields = read ? read.list : [];
    box.replaceChildren.apply(box, groupFields(fill.fields));
    el('forms').hidden = false;
    el('flatten').parentElement.hidden = !fill.fields.length;
    if(failed){ note.textContent = t('fieldsReadFail'); return; }
    var lines = [fill.fields.length ? t('fieldsHint') : t('noFields')];
    if(read.skipped) lines.push(t('fieldsSkipped', read.skipped));
    note.textContent = lines.join(' ');
  }
  /* Only what the visitor changed is written: a field left alone keeps its own look. */
  function changedFields(){
    return fill.fields.filter(function(d){ return !d.readOnly && JSON.stringify(d.read()) !== JSON.stringify(d.value); })
      .map(function(d){ return { name: d.name, type: d.type, value: d.read() }; });
  }

  /* ---------- fonts ---------- */
  /* Per document: the standard font when it can write the text, else Noto
     Sans (embedded whole) for Latin/Greek/Cyrillic, else letter shapes. */
  function fontKit(doc){
    var cache = {};
    function std(){ return cache.std || (cache.std = doc.embedFont(PDFLib.StandardFonts.Helvetica)); }
    function embedNoto(){
      if(!cache.noto) cache.noto = PCTools.fonts.file('latin').then(function(blob){ return blob.arrayBuffer(); }).then(function(buf){
        doc.registerFontkit(window.fontkit);
        return doc.embedFont(new Uint8Array(buf)); // whole font: see the top of this file
      });
      return cache.noto;
    }
    async function plan(text, who){
      var flat = text.replace(/[\r\n\t]/g, ''), helv = await std();
      if(encodes(helv, flat)) return { font: helv };
      try{
        if(!RTL_RE.test(flat) && covers(await PCTools.fonts.font('latin'), flat)){ cache.notoUsed = true; return { font: await embedNoto() }; }
        return { shapes: await shapesOf(text, who) };
      }catch(e){
        if(e && e.userFacing) throw e;
        pcLogUnexpected(e); // network, integrity, fontkit: for whoever debugs it
        throw myError(PCTools.t('wmFont'));
      }
    }
    /* (v157) The embedded fonts a field look may name in its /DA. */
    async function used(){ return [await std()].concat(cache.notoUsed ? [await embedNoto()] : []); }
    return { std: std, plan: plan, used: used };
  }
  function encodes(font, text){
    try{ font.encodeText(text); return true; }
    catch(e){ return false; } // WinAnsi can't write it: another font will (the caller decides)
  }
  function covers(font, text){
    return Array.from(text).every(function(ch){ return /\s/.test(ch) || font.hasGlyphForCodePoint(ch.codePointAt(0)); });
  }
  /* One letter-shape path per line of `text`. */
  async function shapesOf(text, who){
    var lines = text.split(/\r?\n/), out = [];
    for(var i = 0; i < lines.length; i++){
      try{ out.push(lines[i].trim() ? await PCTools.fonts.textPath(lines[i]) : null); }
      catch(e){ if(e && e.chars) throw myError(t('chars', who)); throw e; }
    }
    return out;
  }

  /* ---------- form fields: write ---------- */
  function setValue(f, c){
    var L = PDFLib;
    if(f instanceof L.PDFTextField) f.setText(c.value);
    else if(f instanceof L.PDFCheckBox){ if(c.value) f.check(); else f.uncheck(); }
    else if(f instanceof L.PDFRadioGroup){ if(c.value) f.select(c.value); else f.clear(); }
    else if(f instanceof L.PDFDropdown || f instanceof L.PDFOptionList){ // (v157) the export value goes into /V, see choicesOf
      var values = [].concat(c.value).filter(Boolean);
      if(values.length) setChoice(f, values); else f.clear();
    }
  }
  /* (v157) /V written directly: pdf-lib's setValues only accepts the shown text. /I (the chosen indices) follows. */
  function setChoice(f, values){
    var L = PDFLib, dict = f.acroField.dict, ctx = dict.context;
    var strings = values.map(function(v){ return L.PDFHexString.fromText(v); });
    dict.set(L.PDFName.of('V'), strings.length === 1 ? strings[0] : ctx.obj(strings));
    var order = choicesOf(f).map(function(c){ return c.value; });
    var idx = values.map(function(v){ return order.indexOf(v); }).filter(function(k){ return k >= 0; }).sort(function(a, b){ return a - b; });
    if(idx.length === values.length && idx.length) dict.set(L.PDFName.of('I'), ctx.obj(idx)); else dict.delete(L.PDFName.of('I'));
  }
  /* (v157) A list field as the reader sees it: its shown texts instead of export values (for drawing the look). */
  function shownView(f){
    var L = PDFLib;
    if(!(f instanceof L.PDFDropdown || f instanceof L.PDFOptionList)) return f;
    var choices = choicesOf(f), label = function(v){ var o = choices.filter(function(c){ return c.value === v; })[0]; return o ? o.label : v; };
    var view = Object.create(f);
    view.getSelected = function(){ return f.getSelected().map(label); };
    view.getOptions = function(){ return choices.map(function(c){ return c.label; }); };
    return view;
  }
  function shownText(f){
    var L = PDFLib;
    if(f instanceof L.PDFTextField) return f.getText() || '';
    return shownView(f).getSelected().join('\n');
  }
  var PROVIDERS = function(f){
    var L = PDFLib;
    return f instanceof L.PDFTextField ? L.defaultTextFieldAppearanceProvider
      : f instanceof L.PDFDropdown ? L.defaultDropdownAppearanceProvider : L.defaultOptionListAppearanceProvider;
  };
  async function refreshLook(f, fonts){
    var L = PDFLib;
    if(f instanceof L.PDFCheckBox || f instanceof L.PDFRadioGroup){
      if(f.needsAppearancesUpdate()) f.defaultUpdateAppearances();
      return;
    }
    var plan = await fonts.plan(shownText(f), '“' + f.getName() + '”'), view = shownView(f), draw = PROVIDERS(f);
    if(plan.font){ f.updateAppearances(plan.font, function(_field, widget, font){ return draw(view, widget, font); }); return; }
    f.updateAppearances(await fonts.std(), shapeLook(view, plan.shapes));
  }
  /* The field's own frame (pdf-lib's look without text), then the letter shapes. */
  function shapeLook(f, shapes){
    var L = PDFLib;
    var draw = f instanceof L.PDFTextField ? L.defaultTextFieldAppearanceProvider
      : f instanceof L.PDFDropdown ? L.defaultDropdownAppearanceProvider : L.defaultOptionListAppearanceProvider;
    return function(field, widget, font){
      var empty = Object.create(field);
      empty.getText = function(){ return ''; };
      empty.getSelected = function(){ return []; };
      empty.getOptions = function(){ return []; };
      return L.normalizeAppearance(draw(empty, widget, font)).normal.concat(shapeOps(field, widget, shapes));
    };
  }
  function widgetRotation(widget){
    var mk = widget.getAppearanceCharacteristics(), r = mk ? mk.getRotation() || 0 : 0;
    return ((r % 360) + 360) % 360;
  }
  function daSize(field){
    var m = /([\d.]+)\s+Tf/.exec(field.acroField.getDefaultAppearance() || '');
    return m ? Number(m[1]) : 0;
  }
  /* ponytail: one size, no word wrap and no comb boxes for letter shapes; pdf-lib's own layout does those for font text */
  function shapeOps(field, widget, shapes){
    var L = PDFLib, P = FILL.FIELD_PAD, r = widget.getRectangle(), turned = widgetRotation(widget) % 180 !== 0;
    var w = turned ? r.height : r.width, h = turned ? r.width : r.height;
    var widest = Math.max.apply(null, shapes.map(function(s){ return s ? s.widthAt1 : 0; }).concat([0.001]));
    var size = daSize(field) || Math.min(FILL.FIELD_AUTO_MAX, (h - 2 * P) / (FILL.LINE_EM * shapes.length), (w - 2 * P) / widest);
    var q = field.acroField.getQuadding ? field.acroField.getQuadding() || 0 : 0;
    var ops = [L.pushGraphicsState(), L.rectangle(P / 2, P / 2, w - P, h - P), L.clip(), L.endPath()];
    shapes.forEach(function(s, i){
      if(!s) return;
      var lw = s.widthAt1 * size;
      var x = q === 1 ? (w - lw) / 2 : q === 2 ? w - P - lw : P;
      var y = shapes.length === 1 ? (h - size * FILL.FIELD_CAP) / 2 : h - P - size * (FILL.BASE_EM + i * FILL.LINE_EM);
      ops.push.apply(ops, L.drawSvgPath(s.path, { x: x, y: y, scale: size / FILL.PATH_UNITS, color: L.rgb(0, 0, 0), borderWidth: 0 }));
    });
    ops.push(L.popGraphicsState());
    return ops;
  }
  async function applyFields(doc, changes, fonts){
    var form = doc.getForm();
    for(var i = 0; i < changes.length; i++){
      pcCheckCancel();
      var c = changes[i];
      try{
        var f = form.getField(c.name);
        setValue(f, c);
        await refreshLook(f, fonts);
      }catch(e){
        if(pcIsCancel(e) || (e && e.userFacing)) throw e;
        pcLogUnexpected(e);
        throw myError(t('fieldFail', c.name));
      }
    }
  }
  /* (v157) /NeedAppearances asks a viewer to draw every field again, with the
     font named in its /DA: that threw away the looks built here (Noto Sans,
     letter shapes) and lost non-Latin values in poppler-based readers. Fields
     still without a look get one now (when the form asks for it: all text and
     list fields, as a viewer would), the flag goes, and the fonts the looks
     name are put in /AcroForm /DR. A field that can't be drawn keeps the flag. */
  async function settleAppearances(doc, fonts, changed){
    var L = PDFLib, acro = doc.catalog.lookup(L.PDFName.of('AcroForm'));
    if(!(acro instanceof L.PDFDict)) return;
    var need = acro.lookup(L.PDFName.of('NeedAppearances')) === L.PDFBool.True, ok = true;
    var fields = doc.getForm().getFields();
    for(var i = 0; i < fields.length; i++){
      var f = fields[i];
      if(changed.has(f.getName()) || f instanceof L.PDFSignature || f instanceof L.PDFButton) continue;
      var toggle = f instanceof L.PDFCheckBox || f instanceof L.PDFRadioGroup;
      if(!lacksLook(f, toggle) && (toggle || !need)) continue;
      pcCheckCancel();
      try{ await refreshLook(f, fonts); }
      catch(e){ if(pcIsCancel(e)) throw e; pcLogUnexpected(e); ok = false; } // that field keeps the flag: a viewer draws it
    }
    if(ok) acro.set(L.PDFName.of('NeedAppearances'), L.PDFBool.False);
    addToDr(doc, acro, await fonts.used());
  }
  function lacksLook(f, toggle){
    return f.acroField.getWidgets().some(function(w){ var a = w.getAppearances(), n = a && a.normal; return toggle ? !n : !(n instanceof PDFLib.PDFStream); });
  }
  function addToDr(doc, acro, list){
    var L = PDFLib, ctx = doc.context, dr = acro.lookup(L.PDFName.of('DR'));
    if(!(dr instanceof L.PDFDict)){ dr = ctx.obj({}); acro.set(L.PDFName.of('DR'), dr); }
    var fontsDict = dr.lookup(L.PDFName.of('Font'));
    if(!(fontsDict instanceof L.PDFDict)){ fontsDict = ctx.obj({}); dr.set(L.PDFName.of('Font'), fontsDict); }
    list.forEach(function(font){ var key = L.PDFName.of(font.name); if(!fontsDict.has(key)) fontsDict.set(key, font.ref); });
  }
  /* (v157) The same flattening as the Flatten tool (pcFlatFormFields, pc-pdfcore.js); returns its notes. */
  function flattenForm(doc){
    var r;
    try{ r = pcFlatFormFields(doc); }
    catch(e){ if(pcIsCancel(e)) throw e; pcLogUnexpected(e); throw myError(t('flattenFail')); }
    return [r.failed.length ? t('flattenKept', r.failed.join(', ')) : '', r.formError ? t('flattenFormError') : ''].filter(Boolean);
  }

  /* ---------- text boxes: write ---------- */
  function rgbOf(name){ var c = COLORS[name] || COLORS.black; return PDFLib.rgb(c[0], c[1], c[2]); }
  async function drawTextBox(page, f, b, fonts){
    var L = PDFLib, plan = await fonts.plan(b.text, t('aTextBox')), lines = b.text.split(/\r?\n/);
    var u = b.fx * f.vw, top = b.fy * f.vh, color = rgbOf(b.color), rotate = L.degrees(f.rot);
    lines.forEach(function(line, i){
      if(!line.trim()) return;
      var at = f.toUser(u, f.vh - top - (FILL.BASE_EM + i * FILL.LINE_EM) * b.size);
      if(plan.font) page.drawText(line, { x: at[0], y: at[1], size: b.size, font: plan.font, color: color, rotate: rotate });
      else page.drawSvgPath(plan.shapes[i].path, { x: at[0], y: at[1], scale: b.size / FILL.PATH_UNITS, color: color, borderWidth: 0, rotate: rotate });
    });
  }
  function drawStamp(page, f, b){
    var L = PDFLib, at = f.toUser(b.fx * f.vw, f.vh - b.fy * f.vh); // the stamp's top-left corner, as seen
    page.drawSvgPath(STAMPS[b.kind], { x: at[0], y: at[1], scale: b.size / FILL.STAMP_UNITS, borderColor: rgbOf(b.color),
      borderWidth: FILL.STAMP_LINE, borderLineCap: L.LineCapStyle.Round, rotate: L.degrees(f.rot) });
  }
  async function drawBoxes(doc, boxes, fonts){
    var pages = doc.getPages(), wrapped = new Set();
    for(var i = 0; i < boxes.length; i++){
      pcCheckCancel();
      var b = boxes[i], page = pages[b.page - 1];
      if(!page) throw PCTools.userError('invalidPdf'); // the preview showed this page of the same file
      if(!wrapped.has(page)){ pcWrapContent(doc, page); wrapped.add(page); }
      var f = pcVisualFrame(page); // visible box and /Rotate, as the preview shows the page
      if(b.kind === 'text') await drawTextBox(page, f, b, fonts); else drawStamp(page, f, b);
    }
  }

  /* ---------- the run ---------- */
  async function fillOnePdf(file, changes, boxes, flatten){
    var doc = await PCTools.loadPdfLib(file), fonts = fontKit(doc), notes = [];
    if(changes.length || flatten){
      if(pcXfaKind(doc) === 'hybrid'){ doc.getForm().deleteXFA(); notes.push(pcT('xfaHybridNote', file.name)); } // else Acrobat shows the old XFA values
      await applyFields(doc, changes, fonts);
      await settleAppearances(doc, fonts, new Set(changes.map(function(c){ return c.name; }))); // (v157)
    }
    if(flatten) notes.push.apply(notes, flattenForm(doc));
    await drawBoxes(doc, boxes, fonts);
    pcCheckCancel();
    doc.setModificationDate(new Date());
    // (as Sign, v74) fields that weren't changed keep their look: no redraw of every field on save
    var bytes = await pcSavePdf(doc, { updateFieldAppearances: false });
    return { result: { blob: PCTools.pdfBlob(bytes), filename: baseFileName(file.name) + '-filled.pdf' }, notes: notes };
  }
  async function runFill(files, ctx){
    var file = files[0];
    var changes = fill.previewFor === file ? changedFields() : [];
    var boxes = fill.previewFor === file ? fill.boxes.filter(function(b){ return b.kind !== 'text' || b.text.trim(); }) : [];
    var flatten = fill.previewFor === file && fill.fields.length > 0 && el('flatten').checked;
    if(!changes.length && !boxes.length && !flatten){
      if(!fill.fieldsRead) await PCTools.loadPdfLib(file); // the preview couldn't open it: say why (broken file, password) instead of "change something"
      throw myError(t('nothing'));
    }
    PCTools.resetNotes();
    fillOpenSeq++; // (as Sign) the preview's copy is closed during the job and opened again after
    await closeFillPreview();
    var r;
    try{
      ctx.setProgress(0.2);
      r = await fillOnePdf(file, changes, boxes, flatten);
      ctx.setProgress(1);
    }finally{ openFillPreview(file).catch(pcLogUnexpected); }
    var note = [PCTools.takeNotes()].concat(r.notes, files.length > 1 ? [t('onlyFirst', file.name)] : []).filter(Boolean).join(' ');
    return { results: [r.result], skipped: [], info: t('infoDone'), note: note };
  }

  /* ---------- preview ---------- */
  async function closeFillPreview(){
    var pdf = fill.pdf; fill.pdf = null; fill.pages = 0;
    if(pdf){ try{ await pdf.destroy(); }catch(e){ pcLogUnexpected(e); } }
  }
  function resetEdits(){
    fill.boxes.forEach(function(b){ if(b.el) b.el.remove(); });
    fill.boxes = []; fill.sel = null; fill.fields = []; fill.fieldsRead = false; fill.page = 1;
    el('fields').replaceChildren();
    el('forms').hidden = true;
    el('flatten').checked = false;
    showEditor();
  }
  async function loadFields(bytes, pw){
    var r = await (pw ? openPdfForEdit(bytes, pw) : openPdfForEdit(bytes)); // password and XFA errors go up
    var read;
    try{ read = readFields(r.doc); }
    catch(e){ pcLogUnexpected(e); showFields(null, true); return; }
    showFields(read, false);
  }
  var fillOpenSeq = 0; // see signOpenSeq (tools-more.js)
  async function openFillPreview(file){
    var my = ++fillOpenSeq, pw = PCTools.previewPassword(file); // read now: the run forgets it right after
    if(fill.previewFor !== file) resetEdits();
    fill.previewFor = file;
    await closeFillPreview();
    var work = el('work'), msg = el('preview-error'), task = null;
    msg.hidden = true;
    PCTools.clearPreviewPassword('fill');
    if(!file){ work.hidden = true; return; }
    work.hidden = false;
    try{
      await pcLoadPdfLibs();
      pcRequirePdfJs();
      var bytes = new Uint8Array(await file.arrayBuffer());
      if(!fill.fieldsRead){ await loadFields(bytes, pw); if(my !== fillOpenSeq) return; fill.fieldsRead = true; }
      task = pcGetDocument(Object.assign(pcPdfSource(bytes), pw ? { password: pw } : {}));
      var pdf = await task.promise;
      if(my !== fillOpenSeq){ await PCTools.destroyTask(task); return; }
      task._pcDoc = pdf; fill.pdf = pdf; fill.pages = pdf.numPages; fill.page = Math.min(fill.page, fill.pages) || 1;
      el('place').hidden = false;
      await renderFillPreview();
    }catch(e){
      if(task && fill.pdf !== task._pcDoc) await PCTools.destroyTask(task);
      if(my !== fillOpenSeq) return;
      noPreview();
      if(PCTools.isPasswordError(e)){ PCTools.askPreviewPassword('fill', msg, file, !!pw, openFillPreviewLogged, el('place-title')); return; }
      previewError(e);
    }
  }
  function openFillPreviewLogged(file){ openFillPreview(file).catch(pcLogUnexpected); }
  function noPreview(){
    fill.pages = 0;
    el('stage').hidden = true;
    el('place').hidden = true;
    if(!fill.fieldsRead) el('forms').hidden = true;
  }
  function previewError(e){
    pcLogUnexpected(e);
    PCTools.showPreviewMsg(el('preview-error'), PCTools.reasonOf(e, 'invalidPdf'));
    noPreview();
  }
  async function renderFillPreview(){
    var pdf = fill.pdf;
    try{ await drawFillPreview(pdf); }
    catch(e){ if(fill.pdf === pdf) throw e; } // its document was closed meanwhile (a newer preview)
  }
  function previewWidth(stage){ return Math.min(FILL.PREVIEW_MAX_W, stage.parentElement.clientWidth || FILL.PREVIEW_MAX_W); }
  async function drawFillPreview(pdf){
    var canvas = el('preview'), stage = el('stage');
    if(!pdf || !canvas) return;
    var ticket = ++fill.rendering;
    var page = await pdf.getPage(fill.page);
    try{
      if(ticket !== fill.rendering) return;
      var vp1 = page.getViewport({ scale: 1 });
      stage.hidden = false;
      var cssW = previewWidth(stage);
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var vp = page.getViewport({ scale: PCTools.canvasScale(vp1, Math.min(cssW * dpr / vp1.width, FILL.PREVIEW_MAX_SCALE)) });
      var off = document.createElement('canvas');
      try{
        off.width = Math.max(1, Math.floor(vp.width)); off.height = Math.max(1, Math.floor(vp.height));
        var g = pcCanvas2d(off);
        g.fillStyle = '#ffffff'; g.fillRect(0, 0, off.width, off.height);
        await page.render({ canvasContext: g, viewport: vp }).promise;
        if(ticket !== fill.rendering) return;
        canvas.width = off.width; canvas.height = off.height;
        canvas.getContext('2d').drawImage(off, 0, 0);
      }finally{ pcReleaseCanvas(off); }
      stage.style.width = cssW + 'px';
      fill.vw = vp1.width; fill.vh = vp1.height;
      el('pageinfo').textContent = PCTools.t('signPage', fill.page, fill.pages);
      PCTools.pagerButtons(el('prev'), el('next'), fill.page, fill.pages);
      renderBoxes();
    }finally{ page.cleanup(); }
  }
  function rerender(){
    var file = fill.previewFor;
    renderFillPreview().catch(function(e){ if(fill.previewFor === file) previewError(e); });
  }

  /* ---------- text boxes on the preview ---------- */
  function pxPerPt(){ return el('stage').clientWidth / fill.vw; }
  function boxLabel(b){
    if(b.kind === 'check') return t('checkLabel');
    if(b.kind === 'cross') return t('crossLabel');
    return t('boxLabel', b.text.trim() || t('boxEmpty'));
  }
  function paintBox(b){
    var e = b.el;
    e.style.left = (b.fx * 100) + '%';
    e.style.top = (b.fy * 100) + '%';
    e.style.fontSize = (b.size * pxPerPt()) + 'px';
    e.style.color = CSS_COLORS[b.color];
    if(b.kind === 'text') e.textContent = b.text;
    e.setAttribute('aria-label', boxLabel(b));
    e.classList.toggle('selected', fill.sel === b);
  }
  function stampSvg(kind){
    var NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg'), path = document.createElementNS(NS, 'path');
    svg.setAttribute('viewBox', '0 0 ' + FILL.STAMP_UNITS + ' ' + FILL.STAMP_UNITS);
    svg.setAttribute('aria-hidden', 'true');
    path.setAttribute('d', STAMPS[kind]);
    path.setAttribute('stroke-width', String(FILL.STAMP_LINE));
    svg.appendChild(path);
    return svg;
  }
  function boxEl(b){
    if(b.el) return b.el;
    var e = document.createElement('div');
    e.className = 'fill-box' + (b.kind === 'text' ? '' : ' fill-box--stamp');
    e.tabIndex = 0;
    e.setAttribute('role', 'button');
    e.setAttribute('aria-describedby', 'fill-place-hint');
    if(b.kind !== 'text') e.appendChild(stampSvg(b.kind));
    wireBox(e, b);
    b.el = e;
    return e;
  }
  function renderBoxes(){
    var stage = el('stage');
    fill.boxes.forEach(function(b){
      if(b.page !== fill.page){ if(b.el) b.el.remove(); return; }
      var e = boxEl(b);
      if(e.parentNode !== stage) stage.appendChild(e);
      paintBox(b);
    });
  }
  var posTimer = null;
  function announcePos(b){
    clearTimeout(posTimer);
    posTimer = setTimeout(function(){
      pcAnnounce(t('boxPos', PCTools.t('pct', Math.round(b.fx * 100)), PCTools.t('pct', Math.round(b.fy * 100))));
    }, FILL.POS_ANNOUNCE_MS);
  }
  function moveBox(b, fx, fy){
    b.fx = clamp(fx, 0, FILL.POS_MAX); b.fy = clamp(fy, 0, FILL.POS_MAX);
    paintBox(b);
  }
  function wireBox(e, b){
    var start = null;
    e.addEventListener('pointerdown', function(ev){
      ev.preventDefault();
      select(b);
      e.focus();
      start = { x: ev.clientX, y: ev.clientY, fx: b.fx, fy: b.fy };
      try{ e.setPointerCapture(ev.pointerId); }catch(err){ /* dragging works without capture */ }
      e.classList.add('dragging');
    });
    e.addEventListener('pointermove', function(ev){
      if(!start) return;
      var r = el('stage').getBoundingClientRect();
      moveBox(b, start.fx + (ev.clientX - start.x) / r.width, start.fy + (ev.clientY - start.y) / r.height);
    });
    var end = function(){ start = null; e.classList.remove('dragging'); };
    e.addEventListener('pointerup', end);
    e.addEventListener('pointercancel', end);
    e.addEventListener('focus', function(){ select(b); });
    e.addEventListener('keydown', function(ev){ boxKey(ev, b); });
  }
  function boxKey(ev, b){
    var step = ev.shiftKey ? FILL.KEY_STEP_BIG : FILL.KEY_STEP;
    var moves = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
    if(moves[ev.key]){
      ev.preventDefault();
      moveBox(b, b.fx + moves[ev.key][0], b.fy + moves[ev.key][1]);
      announcePos(b);
      return;
    }
    if(ev.key === 'Delete' || ev.key === 'Backspace'){ ev.preventDefault(); removeBox(b); return; }
    if(ev.key === 'Enter' && b.kind === 'text'){ ev.preventDefault(); el('text').focus(); }
  }
  function select(b){
    if(fill.sel === b) return;
    var old = fill.sel;
    fill.sel = b;
    if(old && old.el) paintBox(old);
    if(b){
      paintBox(b);
      el('size').value = String(b.size);
      el('color').value = b.color;
    }
    showEditor();
  }
  function showEditor(){
    var b = fill.sel, isText = !!b && b.kind === 'text';
    el('edit').hidden = !b;
    el('text-row').hidden = !isText;
    if(isText) el('text').value = b.text;
  }
  function addBox(kind, fx, fy){
    var b = { kind: kind, page: fill.page, fx: clamp(fx, 0, FILL.POS_MAX), fy: clamp(fy, 0, FILL.POS_MAX), text: '',
      size: Number(el('size').value), color: el('color').value, el: null };
    fill.boxes.push(b);
    renderBoxes();
    select(b);
    return b;
  }
  /* "Add text box" (and the stamps) without a click: a free spot near the top left. */
  function addBoxAtDefault(kind){
    var n = fill.boxes.filter(function(b){ return b.page === fill.page; }).length % FILL.NEW_BOX_ROWS;
    var b = addBox(kind, FILL.NEW_BOX_X, FILL.NEW_BOX_Y + n * FILL.NEW_BOX_STEP);
    if(kind === 'text') el('text').focus(); else b.el.focus();
  }
  function removeBox(b){
    var onPage = fill.boxes.filter(function(x){ return x.page === b.page; });
    var next = onPage[onPage.indexOf(b) + 1] || onPage[onPage.indexOf(b) - 1] || null;
    fill.boxes = fill.boxes.filter(function(x){ return x !== b; });
    if(b.el) b.el.remove();
    if(fill.sel === b){ fill.sel = null; showEditor(); }
    pcAnnounce(t('boxRemoved'));
    var to = next && next.el ? next.el : el('place-title');
    if(!to.hasAttribute('tabindex')) to.setAttribute('tabindex', '-1');
    to.focus();
  }
  function setupStage(){
    el('preview').addEventListener('click', function(ev){
      var r = el('stage').getBoundingClientRect();
      var lineFrac = (FILL.LINE_EM * Number(el('size').value) * pxPerPt() / 2) / r.height; // the first line is centred on the click
      addBox('text', (ev.clientX - r.left) / r.width, (ev.clientY - r.top) / r.height - lineFrac);
      el('text').focus();
    });
    el('add').addEventListener('click', function(){ addBoxAtDefault('text'); });
    el('check').addEventListener('click', function(){ addBoxAtDefault('check'); });
    el('cross').addEventListener('click', function(){ addBoxAtDefault('cross'); });
    el('text').addEventListener('input', function(){ if(fill.sel && fill.sel.kind === 'text'){ fill.sel.text = el('text').value; paintBox(fill.sel); } });
    el('size').addEventListener('change', function(){ if(fill.sel){ fill.sel.size = Number(el('size').value); paintBox(fill.sel); } });
    el('color').addEventListener('change', function(){ if(fill.sel){ fill.sel.color = el('color').value; paintBox(fill.sel); } });
    el('delete').addEventListener('click', function(){ if(fill.sel) removeBox(fill.sel); });
    var go = function(step){ fill.page += step; select(null); rerender(); };
    el('prev').addEventListener('click', function(){ if(fill.page > 1) go(-1); });
    el('next').addEventListener('click', function(){ if(fill.page < fill.pages) go(1); });
    // only a new width redraws (iOS fires resize while scrolling); boxes are placed in % of the stage
    window.addEventListener('resize', function(){
      var stage = el('stage');
      if(fill.pdf && Math.abs(previewWidth(stage) - stage.clientWidth) > 1) rerender();
    });
  }

  pcOnPanel('fill', function(){
    setupStage();
    var gate = PCTools.previewGate('fill', openFillPreview, function(){ return fill.previewFor; });
    PCTools.setupTool('fill', {
      accept: PCTools.isPdf, zipName: 'filled-pdf',
      working: function(){ return t('working'); },
      onFiles: function(files){ gate(files[0] || null); },
      run: function(files, _opt, ctx){ return runFill(files, ctx); }
    });
  });
})();
